import { render } from "./UserSearchSelect.vue?vue&type=template&id=4d0f0160&scoped=true"
import script from "./UserSearchSelect.vue?vue&type=script&lang=js"
export * from "./UserSearchSelect.vue?vue&type=script&lang=js"

import "./UserSearchSelect.vue?vue&type=style&index=0&id=4d0f0160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0f0160"]])

export default __exports__